module.exports = __webpack_public_path__ + "static/media/avocado.d68f4ab7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/toppings/avocado.jpg
// module id = 122
// module chunks = 0